// extracted by mini-css-extract-plugin
module.exports = {"thirdImage":"thirdImage_thirdImage__3CgUt","invert":"thirdImage_invert__2v8g8","text":"thirdImage_text__2STY5","pic":"thirdImage_pic__10tt6"};